import { render, staticRenderFns } from "./UiGrid.vue?vue&type=template&id=6f49b406&scoped=true"
import script from "./UiGrid.vue?vue&type=script&lang=ts"
export * from "./UiGrid.vue?vue&type=script&lang=ts"
import style0 from "./UiGrid.vue?vue&type=style&index=0&id=6f49b406&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49b406",
  null
  
)

export default component.exports